import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'



import PartnerHomePage from "./pages/PartnerHomepage.vue";
import AllTransactionsPage from "./pages/AllTransactionsPage.vue";
import MyAccountPage from "./pages/MyAccountPage.vue";
import LoginPage from "./pages/LoginPage.vue";
import OnboardingPage from "./pages/onboardingPages/OnboardingPage.vue";


import ChangeAccountDetailsPage from "./pages/ChangeAccountDetailsPage.vue";
import ForgottenPasswordPage from "./pages/ForgottenPasswordPage.vue";
import ResetPasswordPage from "./pages/ResetPasswordPage.vue";
import SettingsPage from "./pages/SettingsPage.vue";
import TakePaymentPage from "./pages/TakePaymentPage.vue";
import ProfilePictureSelectionPage from "./pages/ProfilePictureSelectionPage.vue";
import GalleryPage from "./pages/GalleryPage.vue";
import fourZeroFourPage from "./pages/errorPages/404Page.vue";
import ChangePersonalDetailsPage from "./pages/ChangePersonalDetailsPage.vue";
import CheckInPage from "./pages/CheckInPage.vue"
import NotificationsPage from "./pages/NotificationsPage.vue"
import browserDetect from "vue-browser-detect-plugin";
import VueRouter from 'vue-router';
import moment from 'moment';
import Vuex from 'vuex';
import store from './store/store';
import { VueReCaptcha } from "vue-recaptcha-v3";

const routes = [
  {
    path: '*',
    redirect: '/',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/onboarding',
    component: OnboardingPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: PartnerHomePage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/MyAccount',
    component: MyAccountPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Login',
    component: LoginPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/AllTransactions',
    component: AllTransactionsPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/forgottenpassword',
    component: ForgottenPasswordPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/resetpassword/:guid',
    component: ResetPasswordPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/changeaccountdetails',
    component: ChangeAccountDetailsPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Settings',
    component: SettingsPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/changeProfilePicture',
    component: ProfilePictureSelectionPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gallery',
    component: GalleryPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/404error',
    component: fourZeroFourPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/changePersonalDetails',
    component: ChangePersonalDetailsPage,
    meta: {
      requiresAuth: true
    },
  },
]

let checkinRoute = {
  path: '/checkIn',
  component: CheckInPage,
  meta: {
    requiresAuth: true
  },
}
let notificationsRoute = {
  path: '/notifications',
  component: NotificationsPage,
  meta: {
    requiresAuth: true
  },
}
let takePaymentRoute = {
  path: '/TakePayment',
  component: TakePaymentPage,
  meta: {
    requiresAuth: true
  }
}

routes.push(notificationsRoute);
routes.push(checkinRoute);
routes.push(takePaymentRoute);

// if (this.accountSettings.notifications){
//   routes.push(notificationsRoute);
//   console.log("notification route added")
// }


// if (this.accountSettings.checkIn)
//   routes.push(checkinRoute);

// if (this.accountSettings.takePayment)
//   routes.push(takePaymentRoute);


const router = new VueRouter({
  routes
})
//To get the router guard working correctly. need to have state for isloggedIn, that saves to local storage.
router.beforeEach((to, from, next) => {
  console.log("To" , to, "FROM", from)
  if (store.getters.getAccountLoggedIn == null) {
    store.commit('initializeAccountLoggedIn');
    let isLoggedIn = JSON.parse(localStorage.getItem('accountLoggedIn'));
    if (isLoggedIn)
      next({ path: '/' })
    else if  (to.meta.requiresAuth){ //This was the other problem. Only re-direct if auth is required
      next({ path: '/Login' })
    }
  }
  if(store.getters.getAccountLoggedIn && to.path != "/reviewing" && to.path !="/onboarding" && to.path !="/onboarding/form" && to.path !="/onboarding/proofs" && to.path !="/onboarding/agreements"){
    console.log("CALLING ROUTER GUARD HERER")
    if(store.getters.getAccount){
      if(store.getters.getAccount.status == "ONBOARDING"){
        return next({path:"/onboarding"});
      }
    }
  }
  if(to.path =="/onboarding" && store.getters.getAccount?.status != "ONBOARDING"){
    return next({path:"/"}); //home
  }
  if (!store.getters.getAccountLoggedIn && to.meta.requiresAuth) {
    next({ path: '/Login' })
  }
  else if (store.getters.getAccountLoggedIn && !to.meta.requiresAuth) {
    next({ path: '/' })
  }
  else {
    next();
  }
})

navigator.serviceWorker.onmessage = function (evt) {
  console.log("Calling onmessage in mainjs");
  window.dispatchEvent(new CustomEvent('newPushNotification', { detail: evt.data }));
}

Vue.config.productionTip = false
Vue.use(browserDetect);
Vue.prototype.moment = moment
Vue.use(VueRouter);
Vue.use(Vuex)
Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});
Vue.use(VueReCaptcha, { siteKey: "6LfmJnkhAAAAAAAz3AG1-S0LeVgyzUl2mS1Yfxe7", loaderOptions:{autoHideBadge: true } });

new Vue({
  router,
  vuetify,
  moment,
  store,
  render: h => h(App)
}).$mount('#app')

